import { IApplicationServices } from './application.types'
import { IApplication } from '@/entities'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppTransformers as transform } from '@/shared/transform'
import { i18n } from "@/plugins/i18n";

export class ApplicationService implements IApplicationServices {

    /** method to get the application template */
    getTemplate(id: number): any {
        return http.get(`api/Application/GetTemplate/${id}`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data.Templates.reduce((obj: any, tmpl: any) => {
                    obj[tmpl.Key] = tmpl.Value;
                    return obj;
                }, {});
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }

    getValidationData(id, data): any {
        console.log(data)
        return http.post(`api/Application/validate/${id}`, data).then((resp: any) => {
            if (resp) {
                return resp;
            } else {
                return {};
            }
        });
    }

    /** method to create new application */
    createApplication(application: IApplication) {
        return http.post('api/Application', application).then((resp: any) => {
            return resp.data;
        })
    }

    /** method to get the application data */
    getApplicationData(id: number): any {
        return http.get(`api/Application/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    /** get the snapshot for the negotiation history */
    getSnapshot(id: number): any {
        return http.get(`api/Application/Snapshot/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    /** method to delete the application */
    deleteApplication(id: number): any {
        return http.delete(`api/Application/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    /** method to get the technical application */
    getTechnicalApplication(id: number): any {
        return http.get(`api/Application/TechnicalApplication/${id}`).then((resp: any) => {
            return resp.data;
        });
    }

    /** method to update the application */
    updateApplication(id: number, application: any): any {
        return http.put(`api/Application/${id}`, application).then((resp: any) => {
            return resp.data
        })
    }

    /** method to update the technical application */
    updateTechnicalApplication(id: number, technicalApplication: any, section = null): any {
        return http.put(`api/Application/TechnicalApplication/${id}/${section}`, technicalApplication)
            .then((resp: any) => {
                return resp.data;
            })
    }

    /** Get the frequency options*/
    getFrequencyOptions(): any {
        return http.get("/api/common/GetLookUp?fieldname=Frequency")
            .then((resp: any) => {
                return resp.data;
            })
    }

    getIndicatorDataTypes(): any {
        return http.get("/api/common/GetLookUp?fieldname=MeasureDataType")
            .then((resp: any) => {
                return resp.data;
            })
    }

    /** create custom indicator the PMP screen */
    createCustomIndicator(indicator: any, transactionId: number): any {
        return http.post(`/api/MEIndicator/Application/Custom/${transactionId}`, indicator)
            .then((resp: any) => {
                return resp.data;
            });
    }

    /** method return list of indicators */
    getIndicators(id: number): any {
        return http.get(`/api/MEIndicator/Hierarchy/${id}`)
            .then((resp: any) => {
                if (resp.data.Result === 'OK') {
                    return resp.data.Record;
                } else {
                    return [];
                }
            });
    }

    /** Get the custom indicator to edit */
    getCustomIndicator(id: number): any {
        return http.get(`/api/MEIndicator/Custom/${id}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            })
    }

    /** update the custom indicator */
    updateCustomIndicator(indicator: any, transactionId: number): any {
        indicator.Entity = 'Application';
        return http.put(`/api/MEIndicator/Custom/${transactionId}`, indicator)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            })
    }

    /** delete the custom indicator */
    deleteCustomIndicator(id: number): any {

    }

    /** transform application data to ES entity model */
    transformAppData(datum: any) {

        var appData = utils.clone(datum);

        var budgetData: any = {};

        // #. series reserved  properties
        const reservedKeys = ['descr', 'activityCode', 'matchFunding', 'details', 'budgetProportions', 'detail_expl', 'activityId', 'variance', 'readOnly'];

        if (appData.applicationBudget && Object.keys(appData.applicationBudget).length > 0) {

            /** get the root properties */
            const { categories, series, data, summary } = appData.applicationBudget;

            budgetData.category = categories;

            budgetData.series = series;

            // #. trasform the data property as object array instead of object prop
            if (data && Object.keys(data).length > 0) {

                budgetData.data_row = (Object.keys(data).reduce((result: any, key: string) => {

                    // #. loop through the line items
                    data[key].forEach((lineItem) => {

                        var obj = { "category_id": key };

                        obj["series_data"] = [];

                        // #. loop through the line item properties
                        Object.keys(lineItem).forEach((prop: string) => {
                            if (reservedKeys.includes(prop)) {
                                obj[prop] = lineItem[prop];
                            } else {
                                let seriesProp = { 'key': prop };
                                Object.assign(seriesProp, lineItem[prop]);
                                obj["series_data"].push(seriesProp);
                            }
                        });

                        result.push(obj);
                    });

                    return result;
                }, []));
            } else {

                budgetData.data_row = {};
            }

            /** parse the summary section */
            if (summary) {
                budgetData.summary = {};

                Object.keys(summary).forEach((summarykey) => {
                    if (summarykey === 'subtotals') {

                        budgetData.summary.subtotals = [];

                        Object.keys(summary.subtotals).forEach((catg) => {

                            // #. set the category id
                            let subTotal = { "category_id": catg };

                            subTotal["series_data"] = [];

                            /** loop through the props */
                            Object.keys(summary.subtotals[catg]).forEach((col) => {
                                if (reservedKeys.includes(col)) {
                                    subTotal[col] = summary.subtotals[catg][col];
                                } else {
                                    let seriesProp = { 'key': col };
                                    Object.assign(seriesProp, summary.subtotals[catg][col]);
                                    subTotal["series_data"].push(seriesProp);
                                }
                            });

                            budgetData.summary.subtotals.push(subTotal);
                        });
                    } else {
                        /** summary line items */
                        budgetData.summary[summarykey] = [];

                        /** get the common properties of summary if any */
                        let commonProps = {};

                        Object.keys(summary[summarykey])
                            .filter(x => reservedKeys.includes(x))
                            .forEach((key) => {
                                budgetData.summary[key] = budgetData.summary[key] || [];
                                budgetData.summary[key].push({ 'item': summarykey, 'value': summary[summarykey][key] });
                            });

                        Object.keys(summary[summarykey])
                            .filter(x => !reservedKeys.includes(x))
                            .forEach((series) => {
                                budgetData.summary[summarykey].push(Object.assign({ series }, summary[summarykey][series]));
                            });
                    }
                })
            }

            budgetData.documentId = appData.applicationBudget?.documentId ?? null;
            appData.applicationBudget = budgetData;
        }

        appData.monitoringPlan = transform.transformPMPModel(appData.monitoringPlan, appData.projectSites);
        appData.timeline = transform.transformTimelineModel(appData.timeline);

        return appData;
    }

    /** transform ES model data to Schema form compatable foramt */
    transformDBEntity(data: any, schema: any, isRAG: boolean, indicators: any) {
        if (schema && schema.properties) {
            let budgetTemplate: any = schema.properties.applicationBudget;

            if (budgetTemplate) {
                let budgetData: any = {};

                // #. series reserved  properties
                const reservedKeys = ['descr', 'activityCode', 'details', 'matchFunding', 'budgetProportions', 'detail_expl', 'activityId', 'variance', 'readOnly'];

                data.applicationBudget = data.applicationBudget || {};

                if (data.applicationBudget) {

                    // #. assign categories, fill from schema if not exists
                    if (data.applicationBudget.category && data.applicationBudget.category.length === budgetTemplate.properties.categories.default.length) {
                        budgetData.categories = data.applicationBudget.category;
                    } else {
                        budgetData.categories = budgetTemplate.properties.categories.default;
                        // Reset the existing entries
                        data.applicationBudget.data_row = [];
                        data.applicationBudget.summary = {};
                    }

                    // #. assign series 
                    // if RAG show only Total
                    if (isRAG && budgetTemplate['x-budgetType'] !== 'tiger') {
                        if (data.applicationBudget.series && data.applicationBudget.series.length > 0)
                            budgetData.series = [data.applicationBudget.series[0]];
                        else {
                            // default values
                            budgetData.series = [budgetTemplate.properties.series.default[0]];
                            data.applicationBudget.data_row = [];
                            data.applicationBudget.summary = {};
                        }
                    } else {
                        if (data.applicationBudget.series && data.applicationBudget.series.length === budgetTemplate.properties.series.default.length) {
                            budgetData.series = data.applicationBudget.series;
                        } else {
                            // default values
                            budgetData.series = budgetTemplate.properties.series.default;
                            // Reset the existing entries
                            data.applicationBudget.data_row = [];
                            data.applicationBudget.summary = {};

                        }
                    }

                    const { data_row, summary } = data.applicationBudget;

                    // #. parse the data rows
                    if (data_row && data_row.length > 0) {

                        // #. make it key value properties from array of props
                        budgetData.data = data_row.reduce((result, lineItem) => {

                            const key = lineItem["category_id"];

                            if (!result[key]) {
                                result[key] = [];
                            }

                            // #. parse the series column
                            const row = Object.keys(lineItem).reduce((out, item) => {

                                if (item === 'series_data') {
                                    lineItem['series_data'].forEach((series) => {
                                        out[series.key] = series;
                                        delete series.key;
                                    })
                                } else if (reservedKeys.includes(item)) {
                                    out[item] = lineItem[item]
                                }
                                return out;
                            }, {});

                            // check and fill the missing series..
                            budgetData.series.forEach((series) => {
                                if (!row[series.name]) {
                                    row[series.name] = {};
                                }
                            });

                            result[key].push(row);

                            return result;

                        }, {});
                    } else {
                        budgetData.data = {};
                    }

                    /** add default value for the missing categories */
                    budgetData.categories.forEach((catg) => {
                        if (!budgetData.data[catg.id]) {
                            budgetData.data[catg.id] = [];
                        }
                    });

                    /*** summary section */
                    budgetData.summary = {};

                    if (budgetTemplate['x-subtotals']) {
                        budgetData.summary.subtotals = {};

                        if (summary && summary.subtotals && summary.subtotals.length > 0) {

                            // #. get the sub total line items
                            summary.subtotals.forEach((subtotal) => {

                                let subTotalProp = {};

                                Object.keys(subtotal).forEach((key) => {
                                    if (key === 'series_data') {
                                        subtotal[key].forEach((total) => {
                                            subTotalProp[total.key] = total;
                                        });

                                    } else {
                                        subTotalProp[key] = subtotal[key];
                                    }
                                });
                                // check and fill the missing series..
                                budgetData.series.forEach((series) => {
                                    if (!subTotalProp[series.name]) {
                                        subTotalProp[series.name] = {};
                                    }
                                });

                                budgetData.summary.subtotals[subtotal["category_id"]] = subTotalProp;
                            })
                        } else {
                            // #. set default value if not exists
                            budgetData.summary.subtotals = budgetData.categories.reduce((obj, item) => {
                                if (!obj[item.id]) {

                                    obj[item.id] = {};
                                    obj[item.id]['descr'] = `${i18n.t('Sub Total')}`;

                                    budgetData.series.forEach((series) => {
                                        obj[item.id][series.name] = {};
                                    });
                                }
                                return obj;
                            }, {});
                        }

                        // #. get the budget data properties
                        Object.keys(budgetTemplate.properties.summary.properties).forEach((summaryKey) => {
                            budgetData.summary[summaryKey] = {};
                            if (summary && summary[summaryKey] && summary[summaryKey].length > 0) {
                                summary[summaryKey].forEach((item) => {
                                    //Object.keys()
                                    budgetData.summary[summaryKey][item.series] = item;
                                    delete budgetData.summary[summaryKey][item.series].series;
                                })
                            } else {
                                budgetData.series.forEach((series) => {
                                    budgetData.summary[summaryKey][series.name] = {};
                                });
                            }
                        });

                        if (summary) {
                            /** update the non series columns */
                            Object.keys(summary)
                                .filter(x => reservedKeys.includes(x))
                                .forEach((x) => {
                                    summary[x].forEach((info) => {
                                        budgetData.summary[info.item][x] = info.value;
                                    })
                                });
                        }
                    }
                }

                data.applicationBudget = budgetData;
            }

            // #. transform the monitoring plan
            let monitoringPlan: any = transform.transformPMPDbEntity(data.monitoringPlan, indicators)

            data.monitoringPlan = {};
            data.monitoringPlan.indicators = monitoringPlan.mapping;
            data.monitoringPlan.data = monitoringPlan.data;

            // #. transform the timeline entry
            let projectTimeline = transform.transformTimelineDbEntity(data.timeline);
            data.timeline = projectTimeline;

        }

        return data;

    }

    /** method to rollback application status */
    rollbackWorkflow(item: any) {
        return http.post(`/api/Workflow/Rollback/${item.LogId}`, item).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }

    /** method to get the applicant summary data */
    getApplicationSummary(id: number): any {
        return http.get(`api/ApplicantSummary/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    /** method to get the application data */
    getApplication(id: number): any {
        return http.get(`api/Application/${id}/Details`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    GetIndicators(id): any {
        return http.get(`api/InitiativeCallMapping/GetIndicators/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }

    CreateIndicatorMapping(item: any): any {
        return http.post(`/api/InitiativeCallMapping`, item).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }

    UpdateIndicators(CallId, IndicatorId, item): any {
        return http.put(`/api/InitiativeCallMapping/${CallId}/${IndicatorId}`, item).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }

    DeleteIndicator(CallId, IndicatorId): any {
        return http.delete(`/api/InitiativeCallMapping/${CallId}/${IndicatorId}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }

    updatePPO(id: number, ppoid: number): any {
        return http.put(`api/Application/${id}/PrimaryProgramOfficer/${ppoid}`, {}).then((resp) => {
            if (resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    ActiveUsersByUserType(userTye): any {
        return http.get(`api/Application/UserType/${userTye}/Active`)
            .then((resp: any) => {
                return resp.data;
            });
    }

    ActiveLeadUsers(userTye): any {
        return http.get(`api/Application/LeadUser/${userTye}/Active`)
            .then((resp: any) => {
                return resp.data;
            });
    }



    /** create custom indicator the PMP screen */
    createCustomIndicatorForImport(indicator: any) {
        return http.post(`/api/MEIndicator/Custom`, indicator)
            .then((resp: any) => {
                return resp.data;
            });
    }

    updateCustomIndicatorForImport(indicator: any): any {
        return http.put(`/api/MEIndicator/Custom/`, indicator)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            })
    }

    changeOwnership(id: number, userId: number, type: string): any {
        return http.post(`api/OwnershipTransfer/${id}/User/${userId}/${type}`, {}).then((resp) => {
            if (resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    transformAppChecklist(data: any, sortKey: string, lang: string): any {
        // Iterate through object and its child
        const transformTitle = (obj, lang) => {
            for (let key in obj) {
                if (obj[key] && typeof obj[key] === 'object') {
                    transformTitle(obj[key], lang);
                }
                else {
                    // Set title based on the language
                    if (obj[key.replace(`-${lang}`, '')] && typeof obj[key] === 'string' && key.includes(`-${lang}`)) {
                        obj[key.replace(`-${lang}`, '')] = obj[key] || obj[key.replace(`-${lang}`, '')];
                    }
                }
            }
        }

        // Function to sort object
        const sortObject = (obj, sortKey) => {
            // Skip if obj is null or not an object
            if (!obj || typeof obj !== 'object' || obj instanceof Array)
                return obj;

            // Sort object keys based on the x-order
            var keys = Object.keys(obj)
                .sort((a, b) => {
                    if (obj[a] && typeof obj[a] === 'object') {
                        return obj[a][sortKey] - obj[b][sortKey];
                    }
                });

            var newObject = {};

            for (var i = 0; i < keys.length; i++) {
                newObject[keys[i]] = sortObject(obj[keys[i]], sortKey)
            }

            return newObject;
        }

        transformTitle(data, lang);
        return sortObject(data, sortKey);
    }

    //Get the Log Framework details from JSON
    transformLogFramworkSchema(data: any, lang: string): any {
        let logData = data['logFramework'];
        let output = {};
        for (let key in logData) {
            if (key === 'properties') {
                if (logData[key]) {
                    for (let subKey in logData[key]) {
                        if (logData[key][subKey]['type'] === 'array') {
                            output = this.parseLogSchema(logData[key][subKey]['items']['properties'], subKey, output, lang);
                        }
                    }
                }
            }
        }

        return output;
    }

    // Iterate through object and its child
    parseLogSchema(properties, subKey, output, lang) {
        output[subKey] = { "Prefix": properties['prefix-' + lang]['title'], "Description": properties['description-' + lang]['title'] };
        for (let key in properties) {
            if (properties[key]['type'] === 'array') {
                this.parseLogSchema(properties[key]['items']['properties'], key, output, lang);
            }
        }
        return output;
    }
}